"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContainer = exports.createModelMeshes = exports.createMesh = exports.prepareRenderData = exports.applyBoneTransforms = exports.createTexture = void 0;
var THREE = __importStar(require("three"));
var geometryBuilder_1 = require("./geometryBuilder");
var geometryTransformer_1 = require("./geometryTransformer");
var svdexGeometry_1 = require("./svdexGeometry");
/**
 * Creates THREE.Texture instance with presets
 */
var createTexture = function (skinBuffer, width, height) {
    var imageData = new ImageData(skinBuffer, width, height);
    var texture = new THREE.Texture(imageData, THREE.UVMapping, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.LinearFilter, THREE.LinearFilter, THREE.RGBAFormat, THREE.UnsignedByteType);
    texture.needsUpdate = true;
    return texture;
};
exports.createTexture = createTexture;
/**
 * Applies bone transforms to a position array and returns it
 */
var applyBoneTransforms = function (vertices, vertIndices, vertBoneBuffer, boneTransforms) {
    var posArray = new Float32Array(vertices.length);
    for (var i = 0; i < vertIndices.length; i++) {
        var transform = boneTransforms[vertBoneBuffer[vertIndices[i]]];
        // The vec3.transformMat4 function was removed from here, because its use
        // (creation of an additional vector) increased the code performance by
        // 4 times. Instead, it uses manual multiplication.
        var x = vertices[i * 3 + 0];
        var y = vertices[i * 3 + 1];
        var z = vertices[i * 3 + 2];
        var w = transform[3] * x + transform[7] * y + transform[11] * z + transform[15] || 1.0;
        posArray[i * 3 + 0] = (transform[0] * x + transform[4] * y + transform[8] * z + transform[12]) / w;
        posArray[i * 3 + 1] = (transform[1] * x + transform[5] * y + transform[9] * z + transform[13]) / w;
        posArray[i * 3 + 2] = (transform[2] * x + transform[6] * y + transform[10] * z + transform[14]) / w;
    }
    return posArray;
};
exports.applyBoneTransforms = applyBoneTransforms;
/**
 * Returns generated mesh buffers and UV-maps of each frame of each sequence of
 * the model
 * @param modelData Model data
 */
var prepareRenderData = function (modelData) {
    var renderData = [];
    var _loop_1 = function (bodyPartIndex) {
        renderData[bodyPartIndex] = [];
        var _loop_2 = function (subModelIndex) {
            renderData[bodyPartIndex][subModelIndex] = [];
            var _loop_3 = function (meshIndex) {
                var textureIndex = modelData.skinRef[modelData.meshes[bodyPartIndex][subModelIndex][meshIndex].skinRef];
                // Unpack faces of the mesh
                var _a = (0, geometryBuilder_1.readFacesData)(modelData.triangles[bodyPartIndex][subModelIndex][meshIndex], modelData.vertices[bodyPartIndex][subModelIndex], modelData.textures[textureIndex]), vertices = _a.vertices, uv = _a.uv, indices = _a.indices;
                var correctElbows = (0, svdexGeometry_1.createSvdexElbowCorrection)(modelData, bodyPartIndex, subModelIndex, vertices, indices);
                renderData[bodyPartIndex][subModelIndex].push({
                    // UV-map of the mesh
                    uvMap: new THREE.BufferAttribute(uv, 2),
                    // List of mesh buffer for each frame of each sequence
                    geometryBuffers: modelData.sequences.map(function (sequence, sequenceIndex) {
                        var bufferAttributes = [];
                        for (var frame = 0; frame < sequence.numFrames; frame++) {
                            var boneTransforms = (0, geometryTransformer_1.calcRotations)(modelData, sequenceIndex, frame);
                            var transformedVertices = (0, exports.applyBoneTransforms)(vertices, indices, modelData.vertBoneBuffer[bodyPartIndex][subModelIndex], boneTransforms);
                            if (correctElbows)
                                correctElbows(transformedVertices, boneTransforms);
                            bufferAttributes.push(new THREE.BufferAttribute(transformedVertices, 3));
                        }
                        return bufferAttributes;
                    })
                });
            };
            for (var meshIndex = 0; meshIndex < modelData.meshes[bodyPartIndex][subModelIndex].length; meshIndex++) {
                _loop_3(meshIndex);
            }
        };
        for (var subModelIndex = 0; subModelIndex < modelData.subModels[bodyPartIndex].length; subModelIndex++) {
            _loop_2(subModelIndex);
        }
    };
    for (var bodyPartIndex = 0; bodyPartIndex < modelData.bodyParts.length; bodyPartIndex++) {
        _loop_1(bodyPartIndex);
    }
    return renderData;
};
exports.prepareRenderData = prepareRenderData;
/**
 * Creates model mesh
 */
var createMesh = function (geometryBuffer, uvMap, texture) {
    // Mesh level
    var material = new THREE.MeshBasicMaterial({
        map: texture,
        side: THREE.DoubleSide,
        transparent: true,
        alphaTest: 0.5
        // color:        0xffffff
    });
    // Prepare geometry
    // Note: `setAttribute` replaced `addAttribute` in three >= r125, but the
    // typings of this project are built for the old version, hence the cast.
    var geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', geometryBuffer);
    geometry.setAttribute('uv', uvMap);
    // Prepare mesh
    return new THREE.Mesh(geometry, material);
};
exports.createMesh = createMesh;
/**
 * Creates list of meshes of every submodel
 */
var createModelMeshes = function (meshesRenderData, modelData, textureBuffers) {
    var textures = textureBuffers.map(function (textureBuffer, textureIndex) {
        var texture = new THREE.Texture(new ImageData(textureBuffer, modelData.textures[textureIndex].width, modelData.textures[textureIndex].height), THREE.UVMapping, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.LinearFilter, THREE.LinearFilter, THREE.RGBAFormat, THREE.UnsignedByteType);
        texture.needsUpdate = true;
        return texture;
    });
    var modelMeshes = meshesRenderData.map(function (bodyPart, bodyPartIndex) {
        // Body part level
        return bodyPart.map(function (subModel, subModelIndex) {
            // Sub model level
            return subModel.map(function (_a, meshIndex) {
                var geometryBuffers = _a.geometryBuffers, uvMap = _a.uvMap;
                var initialGeometryBuffer = geometryBuffers[0][0].clone();
                var textureIndex = modelData.skinRef[modelData.meshes[bodyPartIndex][subModelIndex][meshIndex].skinRef];
                var texture = textures[textureIndex];
                return (0, exports.createMesh)(initialGeometryBuffer, uvMap, texture);
            });
        });
    });
    return modelMeshes;
};
exports.createModelMeshes = createModelMeshes;
/**
 * Creates THREE.js object to render
 */
var createContainer = function (meshes) {
    var container = new THREE.Group();
    // Adding meshes to the container
    meshes.forEach(function (bodyPart) {
        // Body part level
        return bodyPart.forEach(function (subModel) {
            // Sub model level
            return subModel.forEach(function (mesh) {
                // Mesh level
                container.add(mesh);
            });
        });
    });
    var degToRad = THREE.MathUtils
        ? THREE.MathUtils.degToRad // three >= r113
        : THREE.Math.degToRad; // three < r113
    // Sets to display the front of the model
    container.rotation.x = degToRad(-90);
    container.rotation.z = degToRad(-90);
    // Sets to display model on the center of camera
    var boundingBox = new THREE.Box3().setFromObject(container);
    container.position.y = (boundingBox.min.y - boundingBox.max.y) / 2;
    return container;
};
exports.createContainer = createContainer;
